var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import EstablishementPermissions from "./EstablishmentPermissions";
import EstablishmentOption from "./EstablishmentOption";
import Address from "./Address";
var Establishement = /** @class */ (function (_super) {
    __extends(Establishement, _super);
    function Establishement(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.name = '';
        _this.generalTermsConditionsUploadUid = null;
        _this.permissions = new EstablishementPermissions();
        _this.profileRepresentativeUid = null;
        _this.details = new EstablishmentDetails();
        _this.legalAddress = null;
        _this.options = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Establishement.buildFromJson(_this, obj);
        return _this;
    }
    Establishement.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'ticketing') {
                        instance[prop] = new EstablishmentTicketing(json[prop]);
                    }
                    else if (prop === 'permissions') {
                        instance[prop] = new EstablishementPermissions(json[prop]);
                    }
                    else if (prop === 'legalAddress') {
                        instance.legalAddress = new Address(json[prop]);
                    }
                    else if (prop === 'details') {
                        instance.details = new EstablishmentDetails(json[prop]);
                    }
                    else if (prop === 'options') {
                        instance.options = new EstablishmentOption(json[prop]);
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Establishement.prototype.exportToJson = function () {
        var JSONUserPartner = {};
        JSONUserPartner['name'] = this.name;
        JSONUserPartner['generalTermsConditionsUploadUid'] = this.generalTermsConditionsUploadUid;
        JSONUserPartner['permissions'] = this.permissions.exportToJson();
        JSONUserPartner['profileRepresentativeUid'] = this.profileRepresentativeUid;
        JSONUserPartner['details'] = this.details.exportToJson();
        if (this.options) {
            JSONUserPartner['options'] = this.options.exportToJson();
        }
        return JSONUserPartner;
    };
    return Establishement;
}(Model));
export default Establishement;
var EstablishmentTicketing = /** @class */ (function (_super) {
    __extends(EstablishmentTicketing, _super);
    function EstablishmentTicketing(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.publicKeyBase64 = "";
        _this.publicKeyBinary = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        EstablishmentTicketing.buildFromJson(_this, obj);
        return _this;
    }
    EstablishmentTicketing.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    EstablishmentTicketing.prototype.exportToJson = function () {
    };
    return EstablishmentTicketing;
}(Model));
export { EstablishmentTicketing };
var EstablishmentDetails = /** @class */ (function (_super) {
    __extends(EstablishmentDetails, _super);
    function EstablishmentDetails(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        EstablishmentDetails.buildFromJson(_this, obj);
        return _this;
    }
    EstablishmentDetails.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    EstablishmentDetails.prototype.exportToJson = function () {
        var JSON = {};
        if (this.entertainmentLicense) {
            JSON.entertainmentLicense = this.entertainmentLicense;
        }
        JSON.address = this.address;
        JSON.city = this.city;
        JSON.country = this.country;
        JSON.phone = this.phone;
        return JSON;
    };
    return EstablishmentDetails;
}(Model));
export { EstablishmentDetails };
//# sourceMappingURL=Establishment.js.map